import React from "react";
import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";
import styled from "styled-components";

const StyledModal = styled(Modal)`
  .modal-dialog {
    max-width: 90vw;
    height: 90vh;
    margin: 2rem auto;
  }

  .modal-content {
    height: 100%;
  }

  .modal-body {
    padding: 0;
    height: calc(100% - 60px);
  }
`;

const IframeContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const StyledIframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
`;

const PdfViewer = ({ show, onHide, pdfUrl, title }) => {
  // Construir URL para Google Docs Viewer como fallback
  const viewerUrl = pdfUrl
    ? `https://docs.google.com/viewer?url=${encodeURIComponent(
        pdfUrl
      )}&embedded=true`
    : null;

  return (
    <StyledModal show={show} onHide={onHide} centered size="xl">
      <Modal.Header closeButton>
        <Modal.Title>{title || "Vista previa del documento"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <IframeContainer>
          {pdfUrl ? (
            <StyledIframe
              src={viewerUrl}
              title="PDF Viewer"
              type="application/pdf"
            />
          ) : (
            <p>No se pudo cargar el documento</p>
          )}
        </IframeContainer>
      </Modal.Body>
    </StyledModal>
  );
};

PdfViewer.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  pdfUrl: PropTypes.string,
  title: PropTypes.string,
};

export default PdfViewer;
